export const BUG_REPORT_CATEGORIES = [
    { value: "order", label: "Quản lý đơn hàng" },
    { value: "stats", label: "Thống kê báo cáo" },
    { value: "social", label: "Social & Chat" },
    { value: "attendance", label: "Chấm công" },
];
/** Loại lỗi từ Agency Portal — chỉ hiện ở trang admin, không hiện form Social. */
export const AGENCY_SUPPORT_CATEGORIES = [
    { value: "ag_gmv", label: "Agency · GMV / Tổng quan" },
    { value: "ag_orders", label: "Agency · Đơn hàng" },
    { value: "ag_ads", label: "Agency · Chi phí quảng cáo" },
    { value: "ag_products", label: "Agency · Sản phẩm" },
    { value: "ag_reward", label: "Agency · Thưởng doanh số" },
    { value: "ag_debt", label: "Agency · Báo cáo công nợ" },
    { value: "ag_delivery", label: "Agency · Tỉ lệ giao hàng" },
    { value: "ag_money", label: "Agency · Báo cáo dòng tiền" },
    { value: "ag_warehouse", label: "Agency · Kho hàng" },
    { value: "ag_leave", label: "Agency · Đề xuất nghỉ phép" },
    { value: "ag_timesheet", label: "Agency · Chấm công cá nhân" },
    { value: "ag_account", label: "Agency · Đăng nhập / hồ sơ" },
];
export const BUG_REPORT_IMAGE_MAX_BYTES = 2 * 1024 * 1024;
export const BUG_REPORT_VIDEO_MAX_BYTES = 10 * 1024 * 1024;
export const BUG_REPORT_MAX_FILES = 2;
export function bugReportCategoryLabel(value) {
    const found = [...BUG_REPORT_CATEGORIES, ...AGENCY_SUPPORT_CATEGORIES].find((item) => item.value === value);
    return found ? found.label : value || "";
}
